




import Vue from 'vue';
import Oidc from 'oidc-client';
import store from '@/store';

export default Vue.extend({
  name: 'AuthCallback',
  mounted() {
    new Oidc.UserManager({ response_mode: 'query' }).signinRedirectCallback()
      .then((user: Oidc.User) => {
        console.log(user);
        store.commit('setToken', user.access_token);
        if (user.state) {
          this.$router.push(user.state);
        } else {
          this.$router.push('/');
        }
      })
      .catch((e: any) => {
        console.error(e);
      });
  },
});
